// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  height: 100vh;
  width: 100%;
}

.left-side {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #172228;
}

.right-side {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.client-logo-sm {
  max-width: 45%;
  height: auto;
  display: none;
  margin: auto;
}

.client-logo {
  max-width: 45%;
  height: auto;
}

.login-box {
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;  
  margin: 15px;
  text-align: center;
}

.login-title {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.login-box label {
  display: block;
  color: #333;
  text-align: left;
}

.error-message {
  color: #ff4d4d;
  font-size: 1rem; 
  margin-top: 2rem;
  text-align: center;
}

.input-error {
  border-color: #ff4d4d;
}

.login-button[disabled] {
  background-color: #6c757d;
  cursor: not-allowed;
}


@media (max-width: 992px) { 
  .right-side {
    display: none;
  }
  
  .client-logo-sm {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".login-container {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.left-side {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #172228;\n}\n\n.right-side {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n}\n\n.client-logo-sm {\n  max-width: 45%;\n  height: auto;\n  display: none;\n  margin: auto;\n}\n\n.client-logo {\n  max-width: 45%;\n  height: auto;\n}\n\n.login-box {\n  background-color: #fff;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;  \n  margin: 15px;\n  text-align: center;\n}\n\n.login-title {\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.login-box label {\n  display: block;\n  color: #333;\n  text-align: left;\n}\n\n.error-message {\n  color: #ff4d4d;\n  font-size: 1rem; \n  margin-top: 2rem;\n  text-align: center;\n}\n\n.input-error {\n  border-color: #ff4d4d;\n}\n\n.login-button[disabled] {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n\n@media (max-width: 992px) { \n  .right-side {\n    display: none;\n  }\n  \n  .client-logo-sm {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
